<script lang="ts">
export default {
  name: 'Badge',
};
const badgeVariants = cva(
  'tw:inline-flex tw:items-center tw:rounded-full tw:border tw:px-2.5 tw:py-0.5 tw:text-xs tw:font-semibold tw:transition-colors tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-ring tw:focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'tw:border-transparent tw:bg-primary tw:text-base-100 tw:hover:bg-secondary/80',
        secondary: 'tw:border-transparent tw:bg-secondary tw:text-base-100 tw:hover:bg-secondary/80',
        destructive: 'tw:border-transparent tw:bg-destructive tw:text-destructive-foreground tw:hover:bg-destructive/80',
        outline: 'tw:text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
  variant?: BadgeVariants['variant'];
}

const props = defineProps<Props>();

const badgeClass = computed(() => cn(badgeVariants({ variant: props.variant }), props.class));
</script>

<template>
  <div :class="badgeClass" v-bind="$attrs">
    <slot />
  </div>
</template>
